
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
// QuestionCustom
import {
  EnumQuestionType,
  Option,
  QuestionCustom,
  QuestionV2,
  QuestionV2Object
} from "@/lib/model/exambuilder/question-v2";
import Editor from "@/components/editor/classic-editor.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import gateway from "@/lib/request/gateway";
import UploadLoading from "@/views/ai-builder-v3/components/upload-loading.vue";
import Auth from "@/lib/common/auth";
import { BlankQuestionAnswer } from "@/lib/model/exam/candidate-answer";
import Editor5 from "@/components/editor/classic-editor5.vue";
import Template from "@/views/ai-builder/components/template.vue";
@Component({
  components: { Template, Editor5, UploadLoading, Editor, InputNumberV3 }
})
export default class QuestionEditV3 extends Vue {
  @Prop({ type: Boolean, default: false }) show!: boolean;
  @Prop({ type: String, default: "" }) title?: string;
  @Prop({ type: QuestionV2, default: new QuestionV2() }) question!: QuestionV2;
  @Prop({ type: String, default: "" }) dimension!: string; //维度键
  get visible() {
    // if (this.show) {
    // this.initData();
    // this.initTab();
    // }
    return this.show;
  }
  set visible(value) {
    this.$emit("update:show", value);
  }
  get isBlankDesc() {
    // eslint-disable-next-line no-useless-escape
    // const reg1 = new RegExp(//, "g");
    // const t1 = this.questionCustomStruct.desc.replace(reg1, "{__TAG__}");
    //
    // console.log(t1);

    const reg2 = new RegExp(/([(（][)）])/, "g");
    const list = this.questionCustomStruct.desc.split(reg2);
    console.log(list);

    let text = "";
    let index = 1;

    list.forEach(el => {
      if (reg2.test(el)) {
        text = text + `{填空${index}}`;
        index += 1;
      } else {
        text = text + el;
      }
    });
    return text;
  }
  set isBlankDesc(value) {
    // const reg = /\{填空\}/g;
    const reg = new RegExp(/{填空(\d+)}/, "g");
    this.questionCustomStruct.desc = value.replace(reg, "()");
  }
  // isBlankDesc = "";
  questionCustomStruct = new QuestionV2();
  isBlankDescChange(value: string) {
    if (!this.isParentChange) {
      this.isBlankDesc = value;
    }
    this.isParentChange = false;
    // let oldText = "";
    // const reg1 = new RegExp(/{填空\d+}/, "g");
    // console.log("set: ", value.replace(reg1, "()"));
    // oldText = value.replace(reg1, "()");
    // // eslint-disable-next-line no-useless-escape
    // const reg = new RegExp(/\(\)|\（\）/, "g");
    // console.log("get: ", value);
    // const list = oldText.split(reg);
    // // console.log(list, 'listlistlistlist111')
    // let text = "";
    // let accont = 1;
    // list.forEach((el, index) => {
    //   if (!el) {
    //     text = text + `{填空${accont}}`;
    //     accont += 1;
    //   } else {
    //     text = text + el;
    //   }
    // });
    // this.isBlankDesc = text;
  }
  created() {
    this.initData();
    this.initTab();
  }
  @Watch("questionCustomStruct.desc", {
    //题干
    immediate: true,
    deep: true
  })
  getBlankNum(old: any) {
    if (this.questionCustomStruct.questionType === 5) {
      //阻止中文括号报错
      // eslint-disable-next-line no-useless-escape
      const reg = /\(\)|\（\）/g;
      const blankNum = this.questionCustomStruct.desc.match(reg)?.length || 0; //括号对数
      const answer = this.questionCustomStruct.blankQuestionConfig.answerList;
      while (answer.length !== blankNum) {
        if (answer.length < blankNum) {
          answer.push(new BlankQuestionAnswer());
        } else {
          answer.pop();
        }
      }
    }
  }
  closeDrawer() {
    this.close();
    this.$emit("update:show", false);
  }
  type = 1;
  list = [];
  switchOfAppendDesc = false;
  switchOfMp3 = false;
  radio = 0;
  desc = 100;
  getTabIndexFormQuestionType(type: number) {
    //选择题7 音频题8 填空题5 兜底视频题0
    const ob = { 7: 1, 8: 2, 5: 3 };
    return ob[type] || 1;
  }
  initTab() {
    this.type = this.getTabIndexFormQuestionType(this.question.questionType);
    this.changeQuestionType(
      this.getTabIndexFormQuestionType(this.question.questionType)
    );
  }
  currentTabIndex = 1;
  changeQuestionType(typeIndex: number) {
    // if (typeIndex == this.currentTabIndex) return;
    switch (typeIndex) {
      case 0:
        this.questionCustomStruct.questionType =
          EnumQuestionType.EnumQuestionTypeVideo;
        break;
      case 1:
        this.questionCustomStruct.questionType =
          EnumQuestionType.EnumQuestionTypeNewSingleChoice;
        break;
      case 2:
        this.questionCustomStruct.questionType =
          EnumQuestionType.EnumQuestionTypeMP3;
        break;
      //填空
      case 3:
        // this.questionCustomStruct;
        this.questionCustomStruct.questionType =
          EnumQuestionType.EnumQuestionTypeBlanks;
        // this.$set(
        //   this.questionCustomStruct,
        //   "questionType",
        //   EnumQuestionType.EnumQuestionTypeBlanks
        // );
        // this.disabledDimList = ["形象素质"];
        break;
    }
    this.currentTabIndex = typeIndex;
    this.$forceUpdate();
  }

  // 维度变化
  @Watch("dimension", { immediate: true, deep: true })
  dimensionChange() {
    this.initNewQuestionData();
  }

  initNewQuestionData() {
    this.questionCustomStruct.dimensionKeyList = [this.dimension];
    this.questionCustomStruct.optionList = [
      new Option(),
      new Option(),
      new Option(),
      new Option()
    ];
    this.questionCustomStruct.scoreRuleList = [];

    // if (!this.canEditIndustryPosition) {
    //   this.questionCustomStruct.questionIndustryId = this.exam.industryId;
    //   this.questionCustomStruct.questionPositionId = this.exam.positionId;
    // }
    //
    // if (this.fromDimension)
    //   this.questionCustomStruct.dimensionKeyList.push(this.fromDimension);
    // while (this.questionCustomStruct.optionList.length < 4) {
    //   const option = new Option();
    //   option.defaultScorePercent = undefined;
    //   this.questionCustomStruct.optionList.push(option);
    // }
  }
  filename = "";
  fileUrl = "";
  audioTime = 0;
  uploadMp3(data: { filename: string; file: File }) {
    const { file } = data;
    const isMP3 = file.name.split(".")[1] === "mp3";
    const isLt5M = file.size < 1024 * 1024 * 5;
    // 上传图片到oss
    if (!isMP3) {
      this.$message.error("上传图片只能是 MP3 格式!");
      return;
    }
    if (!isLt5M) {
      this.$message.error("上传音频过大!");
      return;
    }
    this.filename = file.name;
    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        const tempUrl = postRes.cdn + "/" + encodeURIComponent(postRes.dir);
        gateway.upload(postRes, file).then((res: any) => {
          this.questionCustomStruct.audioDescUrl = tempUrl;
          this.questionCustomStruct.audioDescFilename = file.name;
          this.getAudioTime(tempUrl);
          // this.isLoading = false;
        });
      }
    });
  }
  getAudioTime(url: string) {
    const audio = new Audio();
    audio.src = url;
    const countAudioTime = async () => {
      while (isNaN(audio.duration) || audio.duration === Infinity) {
        await new Promise(resolve => setTimeout(resolve, 200));
        audio.currentTime = 10000 * Math.random();
      }
      this.questionCustomStruct.audioDescDuration = audio.duration;
    };
    countAudioTime();
  }
  delAudio() {
    // this.filename = "";
    // this.fileUrl = "";
    // this.audioTime = 0;
    this.questionCustomStruct.audioDescFilename = "";
    this.questionCustomStruct.audioDescDuration = 0;
    this.questionCustomStruct.audioDescUrl = "";
  }
  get token() {
    return Auth.token;
  }
  onChangeOption(option: Option) {
    console.log(option);
    if (option.defaultScorePercent != undefined) {
      option.showScoreErr = false;
    }
    const contentOnlyText = option.content.replace(/<.*?>/gi, "");
    if (contentOnlyText.length <= 25 && contentOnlyText.length > 0)
      option.showContentErr = false;
    else if (contentOnlyText.length > 25) {
      // 一旦输入超过字数直接就变红
      // option.showContentErr = true;
    }
  }
  addOption() {
    if (this.questionCustomStruct.optionList.length < 10) {
      const option = new Option();
      option.defaultScorePercent = 0;
      this.questionCustomStruct.optionList.push(option);
    } else {
      // this.$message({
      //   duration: 3000,
      //   message: "请至少选择一个胜任力维度",
      //   type: "error",
      //   offset: 400
      // });
    }
  }
  delOption(index: number) {
    if (this.questionCustomStruct.optionList.length == 1) {
      // this.$message({
      //   duration: 2000,
      //   message: "请至少输入一个选项",
      //   type: "error",
      //   offset: 200
      // });
      return;
    }

    this.questionCustomStruct.optionList.splice(index, 1);
  }
  async saveData() {
    console.log(this.questionCustomStruct);
    let checkResult = true;
    //表单
    if (this.questionCustomStruct.desc == "") {
      this.$message({
        duration: 2000,
        message: "请填写题目描述",
        type: "error"
        // offset: 150
      });
      checkResult = false;
      return checkResult;
    }
    // 选项
    if (this.questionCustomStruct.isSingleSelect()) {
      let has100Option = false;
      let undefindOptionNum = 0;
      for (let i = 0; i < this.questionCustomStruct.optionList.length; i++) {
        const option = this.questionCustomStruct.optionList[i];
        if (option.defaultScorePercent == 100) has100Option = true;

        // 检查是否为空
        if (option.content == "" || option.defaultScorePercent == undefined) {
          // 如果同时为空，则可以去掉
          if (option.content == "" && option.defaultScorePercent == undefined) {
            undefindOptionNum++;
          }
          //   checkResult = false;
          // } else {
          //   if (option.content == "") option.showContentErr = true;
          //   if (option.defaultScorePercent == undefined)
          //     option.showScoreErr = true;
          //   checkResult = false;
          // }
          if (!option.content) {
            this.$message({
              duration: 2000,
              message: "请输入选项内容",
              type: "error",
              offset: 200
            });
            option.showContentErr = true;
          }
          if (option.defaultScorePercent !== 0 && !option.defaultScorePercent) {
            option.showScoreErr = true;
          }
          this.$forceUpdate();
          console.log(
            this.questionCustomStruct.optionList,
            "this.questionCustomStruct.optionList[i]"
          );
          checkResult = false;
        }
        // 检查选项长度
        // const contentOnlyText = option.content.replace(/<.*?>/gi, "");
        // if (contentOnlyText.length > 25) {
        // option.showContentErr = true;
        // checkResult = false;
        // this.$message({
        //   duration: 2000,
        //   message: "选项字数不可超过25字",
        //   type: "error",
        //   offset: 200
        // });
        //   return checkResult;
        // }
      }
      //选项为空
      if (undefindOptionNum > 0) {
        this.$message({
          duration: 2000,
          message: "请输入选项内容",
          type: "error",
          offset: 200
        });
        checkResult = false;
        return checkResult;
      }

      if (!has100Option) {
        checkResult = false;
        this.$message({
          duration: 2000,
          message: "请保证至少一个选项的权重为100%",
          type: "error",
          offset: 200
        });
      }
    }
    if (
      this.questionCustomStruct.isBlank() &&
      this.questionCustomStruct.blankQuestionConfig.answerList
    ) {
      if (
        this.questionCustomStruct.blankQuestionConfig.answerList.length > 10
      ) {
        this.$message.error("填空题目最多创建10个空!");
        checkResult = false;
      }
      this.questionCustomStruct.blankQuestionConfig.answerList.forEach(
        (el, index) => {
          if (!el.words) {
            const element = this.$refs["answerList" + index];
            console.log(
              this.$refs["answerList" + index],
              'this.$refs["answerList'
            );
            element[0].$el.className += " optionClass-err";
            this.$message.error("请填写填空项正确答案!");
            checkResult = false;
          }
        }
      );
    }
    // if (
    //   this.questionCustomStruct.isBlank() &&
    //   this.questionCustomStruct.blankQuestionConfig.scoreType === 3
    // ) {
    //   const have100 = this.questionCustomStruct.blankQuestionConfig.answerList.reduce(
    //       (acc, el) => acc + el.score
    //   , 0);
    //   if (have100 !== 0) {
    //     checkResult = false;
    //     this.$message({
    //       duration: 2000,
    //       message: "所有选项之和必须为100%",
    //       type: "error",
    //       offset: 200
    //     });
    //   }
    // }
    if (!checkResult) {
      console.log(this.questionCustomStruct);
      return;
    }
    // 清理选择题选项
    if (!this.questionCustomStruct.isSingleSelect()) {
      this.questionCustomStruct.optionList = [];
    } else {
      this.questionCustomStruct.scoreRuleList = [];
      //单选 删除为空的选项
      for (let i = 0; i < this.questionCustomStruct.optionList.length; i++) {
        if (
          this.questionCustomStruct.optionList[i].content == "" &&
          this.questionCustomStruct.optionList[i].defaultScorePercent ==
            undefined
        ) {
          this.questionCustomStruct.optionList.splice(i, 1);
          i--;
        }
      }
    }
    // 提交数据
    let res;

    if (this.questionCustomStruct && this.questionCustomStruct.questionId) {
      res = await QuestionV2Object.update(
        this.questionCustomStruct.questionId,
        this.questionCustomStruct
      );
    } else {
      res = await QuestionV2Object.create(this.questionCustomStruct);
    }

    this.$emit("updateData", res);
    this.close(true);
  }
  cancelSave() {
    this.close();
  }
  isParentChange = false; // 是否父级变更组件值
  blankInit() {
    if (this.questionCustomStruct.blankQuestionConfig.answerList.length >= 10) {
      return;
    }
    const editor = this.$refs.editor as any;
    editor.insertData();
    // setTimeout(() => {
    //   // 走宏任务让blur 事件优先触发进行光标位置赋值
    //   const text = this.isBlankDesc;
    //   console.log(this.isBlankDesc);
    //   let newValue;
    //   if (this.insertPostion) {
    //     newValue =
    //       text.slice(0, this.insertPostion) +
    //       "{填空1}" +
    //       text.slice(this.insertPostion);
    //     this.isBlankFocusFlag = false;
    //   } else {
    //     newValue = this.isBlankFocusFlag ? "{填空1}" + text : text + "{填空1}";
    //     this.isBlankFocusFlag = false;
    //   }
    //   this.isBlankDesc = newValue;
    //   this.isParentChange = true;
    //   // this.$refs.editor?.setValue(newValue);
    //   // this.questionCustomStruct.desc = this.questionCustomStruct.desc + "()";
    // }, 150);
    // this.isBlankDesc = this.isBlankDesc + "()";
  }
  initData() {
    if (this.question.questionId == 0) {
      // 创建题目
      this.initNewQuestionData();
    } else {
      // 编辑题目
      this.currentTabIndex = this.getTabIndexFormQuestionType(
        this.question.questionType
      );
      // this.questionCustomStruct.assign(this.question);
      for (const key in this.question) {
        this.$set(this.questionCustomStruct, key, this.question[key]);
      }
      const b = this.questionCustomStruct;
      if (this.questionCustomStruct.appendDesc) {
        this.switchOfAppendDesc = true;
      } else {
        this.switchOfAppendDesc = false;
      }
      if (this.questionCustomStruct.audioDescFilename) {
        this.filename = this.questionCustomStruct.audioDescFilename;
        this.switchOfMp3 = true;
      }
      this.radio = this.questionCustomStruct.audioDescPlayTimeLimit > 0 ? 1 : 0;
      // debugger;
      // assign出来的optionList没监听
      const optionList = [];
      for (const option of this.questionCustomStruct.optionList) {
        optionList.push(option);
      }
      this.questionCustomStruct.optionList = optionList;
      this.initTab();
    }
    // this.dataLoaded = true;
  }
  close(flag = false) {
    this.$emit("close", flag);
    this.questionCustomStruct = new QuestionV2();
    this.questionCustomStruct.questionType = 1;
    this.desc++;
    this.type = 1;
    this.switchOfAppendDesc = false;
    this.switchOfMp3 = false;
    this.visible = false;
  }
  answerListChange(value: string, index: number) {
    if (value) {
      const dom = this.$refs["answerList" + index][0];
      dom.$el.className = dom.$el.className.replace("optionClass-err", "");
    }
  }
  editorChange(value: any, key: string) {
    // const ref = this.$refs[key] as any;
    // ref.setData(value.replace(/<img.*?>/gi, ""));
  }
  checkBoxChange(value: any, key: string) {
    this.questionCustomStruct[key] = value;
  }
  radioChange(value: number) {
    if (value === 1) {
      this.questionCustomStruct.audioDescPlayTimeLimit = 1;
    } else {
      this.questionCustomStruct.audioDescPlayTimeLimit = 0;
    }
  }
  descFocus() {
    const select = this.$refs["typeSelect"] as any;
    if (select) {
      select.blur();
    }
  }
}
